import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Transition as _Transition, Fragment as _Fragment } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { class: "topPanel topPanel-skeleton" };
const _hoisted_3 = { class: "transactions-skeleton" };
const _hoisted_4 = { key: 0 };
const _hoisted_5 = {
    class: "topPanel",
    style: {}
};
const _hoisted_6 = { class: "drawer-content" };
import { ref, getCurrentInstance, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { useBanking, pendingBankingRevalidate } from '@/composables/useBanking';
import { useTransactionUpdateHandoff } from '@/composables/useTransactionUpdateHandoff';
import BankCard from './elements/BankCard.vue';
import SimpleDrawerPanel from './elements/SimpleDrawerPanel.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import TransactionsList from './elements/TransactionsList.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'AccountPage',
    setup(__props) {
        const route = useRoute();
        const router = useRouter();
        const state = useAppState();
        useAuth();
        const { getCustomer } = useCustomer();
        const { getBankAccount, deleteBankAccount, clearBankingInfo, getBankingInfo } = useBanking();
        const { updatingTransactionId, takePending, } = useTransactionUpdateHandoff();
        const instance = getCurrentInstance();
        const cookies = instance?.appContext.config.globalProperties.$cookies;
        const drawerOpen = ref(false);
        function peekingDrawerBottom() {
            const c = cookies?.get('sb');
            let ret = 44;
            if (c) {
                ret += parseInt(c);
            }
            return ret + 'px';
        }
        function onTransactionClick(t) {
            if (!t?.id)
                return;
            router.push('/TransactionDetail/' + t.id);
        }
        function editAccount() {
            router.push('/Accounts/Current/Edit/' + route.params.id);
        }
        function deleteAccount() {
            deleteBankAccount(route.params.id, () => {
                clearBankingInfo();
                getBankingInfo(null, true);
                router.push('/money');
            });
        }
        onMounted(() => {
            getCustomer();
            const pending = takePending();
            // SWR keeps cache responsive on normal navigation; pollUntilChanged kicks in
            // when we've just come from a write (category or tag change) so the row
            // keeps SWR-polling against the cached stale until the server payload
            // reflects the update — also clears the category-handoff row spinner.
            const revalidate = !!pending.id || pendingBankingRevalidate.value;
            pendingBankingRevalidate.value = false;
            getBankAccount(route.params.id, (_result, isStale) => {
                if (!isStale)
                    updatingTransactionId.value = null;
            }, 
            /* lite */ false, 
            /* refreshCache */ false, 
            /* staleWhileRevalidate */ true, 
            /* pollUntilChanged */ revalidate);
        });
        return (_ctx, _cache) => {
            const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    del: true,
                    edit: true,
                    onDelete: deleteAccount,
                    onEdit: editAccount,
                    title: _unref(state).bankAccount ? (_unref(state).bankAccount.bank.prettyName ? _unref(state).bankAccount.bank.prettyName : _unref(state).bankAccount.bank.name) : 'Account',
                    bgcolor: '#332847',
                    color: 'white',
                    border: false
                }, null, 8, ["title"]),
                (!_unref(state).customer || !_unref(state).bankAccount)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _createVNode(_component_v_skeleton_loader, {
                                type: "image",
                                class: "bank-card-skeleton"
                            })
                        ]),
                        _createElementVNode("div", _hoisted_3, [
                            _createVNode(_component_v_skeleton_loader, { type: "list-item-avatar-two-line, list-item-avatar-two-line, list-item-avatar-two-line, list-item-avatar-two-line" })
                        ])
                    ]))
                    : _createCommentVNode("", true),
                _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                        (_unref(state).customer && _unref(state).bankAccount)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, [
                                    _createVNode(BankCard, {
                                        account: _unref(state).bankAccount,
                                        formatter: _unref(state).formatter
                                    }, null, 8, ["account", "formatter"])
                                ]),
                                _createVNode(SimpleDrawerPanel, {
                                    modelValue: drawerOpen.value,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((drawerOpen).value = $event)),
                                    title: "Recent Transactions",
                                    peekHeight: "52%",
                                    peekBottom: peekingDrawerBottom(),
                                    peekContentVisible: true,
                                    closeButton: true
                                }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_6, [
                                            _createVNode(TransactionsList, {
                                                showDateTotal: true,
                                                search: true,
                                                transactions: _unref(state).bankAccount.groupedTransactions,
                                                formatter: _unref(state).formatter,
                                                today: _unref(state).today,
                                                yesterday: _unref(state).yesterday,
                                                updatingTransactionId: _unref(updatingTransactionId),
                                                onTransactionClick: onTransactionClick,
                                                categoryPills: true,
                                                excludedFilter: true
                                            }, null, 8, ["transactions", "formatter", "today", "yesterday", "updatingTransactionId"])
                                        ])
                                    ]),
                                    _: 1
                                }, 8, ["modelValue", "peekBottom"])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                })
            ], 64));
        };
    }
});
